<template>
  <div :class="`marketing-pad marketing-pad--${alignment}`">
    <div class="marketing-pad__text-container">
      <span class="marketing-pad__text">
        <span v-html="text" />
      </span>
    </div>
    <div class="marketing-pad__image-container">
      <img v-if="image" :src="image" :alt="text" />
      <vb-icon
        v-else-if="icon"
        class="marketing-pad__icon"
        :name="icon"
        :size="90"
        :dot_size="30"
        dotted
      ></vb-icon>
    </div>
  </div>
</template>

<script>
export default {
  name: "marketing-pad",
  props: {
    text: String,
    image: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    alignment: {
      type: String,
      default: "left",
    },
  },
};
</script>

<style lang="scss" scoped>

  .marketing-pad {
    $this: &;
    display: flex;
    background: $white;
    overflow: hidden;
    border-radius: $border-radius-lg * 2;
    min-height: 160px;

    @include media-breakpoint-down(lg) {
      display: none;
      width: 0 !important;
      height: 0 !important;
      margin-top: -24px !important;
    }

    &--left {
      flex-direction: row;
    }
    &--right {
      flex-direction: row-reverse;
    }

    &__text-container {
      font-size: $font-size-xl;
      line-height: normal;
      padding: ($grid-gutter-20*2) 0;
      flex-basis: 70%;
      display: flex;
      gap: $grid-gutter-width / 2;
      align-items: center;

      #{$this}--left & {
        padding-right: $grid-gutter-20;
        padding-left: ($grid-gutter-width*2);
      }

      #{$this}--right & {
        padding-left: $grid-gutter-20;
        padding-right: ($grid-gutter-width*2);
      }
    }

    &__text {
      display: flex;

      &:before {
        content: '';
        width: $grid-gutter-width / 3;
        min-height: 100%;
        border-radius: $border-radius;
        background-color: var(--secondary);
        margin-right: $grid-gutter-width / 2;
      }

    }

    &__image-container {
      flex-basis: 30%;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        height: 100%;
        object-fit: cover;
        display: block;
        margin: 0 auto;
      }
    }

    &__icon {
      margin: auto;
      width: 90px;
    }
  }
</style>
